"use client";
import { deleteDocumentCookie } from "@packages/lib/utlils/cookie-utils";
import { useEffect } from "react";

export default function ClearfilterValues() {
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("filter_param");
      deleteDocumentCookie({ name: "filter_param" });
    };
  }, []);

  return null;
}
